// Mega menus are <details name="nav"> elements, so they open, close and
// stay exclusive without JavaScript. This adds hover intent on desktop,
// Escape and outside-click closing, and the mobile drawer.
const fine = window.matchMedia('(hover: hover) and (pointer: fine) and (min-width: 60.01rem)');

export function initNav() {
  // A shadow under the sticky header once the page scrolls.
  const header = document.querySelector('[data-header]');
  if (header) {
    const onScroll = () => header.toggleAttribute('data-scrolled', window.scrollY > 8);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
  }

  const menus = [...document.querySelectorAll('details.mega')];
  const closeAll = (except) => menus.forEach((d) => { if (d !== except) d.open = false; });

  for (const d of menus) {
    // Fallback for browsers without exclusive <details name>.
    d.addEventListener('toggle', () => { if (d.open) closeAll(d); });

    let timer;
    d.addEventListener('pointerenter', () => {
      if (!fine.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { d.open = true; }, 90);
    });
    d.addEventListener('pointerleave', () => {
      if (!fine.matches) return;
      clearTimeout(timer);
      timer = setTimeout(() => { d.open = false; }, 220);
    });
  }

  document.addEventListener('click', (e) => {
    if (!e.target.closest('details.mega')) closeAll();
  });
  document.addEventListener('keydown', (e) => {
    if (e.key !== 'Escape') return;
    const open = menus.find((d) => d.open);
    if (open) {
      open.open = false;
      open.querySelector('summary').focus();
    }
    if (document.documentElement.classList.contains('nav-open')) toggleDrawer(false);
  });

  const toggle = document.querySelector('[data-menu-toggle]');
  const toggleDrawer = (force) => {
    const open = document.documentElement.classList.toggle('nav-open', force);
    toggle?.setAttribute('aria-expanded', String(open));
  };
  if (toggle) {
    toggle.setAttribute('role', 'button');
    toggle.setAttribute('aria-expanded', 'false');
    toggle.addEventListener('click', (e) => {
      e.preventDefault();
      toggleDrawer();
    });
  }
}
